import React from "react";
import { useNavigate } from "react-router-dom";
import Variable from "components/variable";
import Icons from "components/icons";
import { useActiveMenuItem, useBreadCrumbs, useMe } from "components/use-hooks";
import { PageWrapDefault } from "components/layout";
import Localize, { localizeByKey } from "components/service/localize";
import { PermissionButton } from "components/permissions";
import VariableConst from "components/variable/variable-const";
import { usePageNavbarPermissions } from "components/permissions/hooks/use-page-navbar-permissions";
import GraphicConst from "components/graphic/graphic-const";

import "./variable.scss";

const VariableGroupPage = () =>
{
  const navigate = useNavigate();

  const basePath = Variable.Const.basePath;

  useActiveMenuItem([ "variable-lists" ], [ "variable-lists" ]);

  const breadcrumbs = [
    {
      label: localizeByKey("BREADCRUMBS.Label_VariableLists"),
      path: basePath,
    },
  ];

  useBreadCrumbs(breadcrumbs);

  const { me } = useMe();
  const isDeveloper = me?.roles?.some((role: any) => role.slug === 'role_developer');

  const pageNavbar = [
    {
      label: localizeByKey("NAVBAR_PAGES.Label_VariableLists"),
      path: "variable-lists",
      permission: VariableConst.permissions.VIEW,
    },
    {
      label: localizeByKey("NAVBAR_PAGES.Label_GraphicRules"),
      path: "graphic-rules",
      permission: GraphicConst.permissions.VIEW,
    },
    ...(isDeveloper ? [{
      label: localizeByKey("NAVBAR_PAGES.Label_Permissions"),
      path: "permissions",
    }] : []),
  ];

  const { filteredNavbarItems } = usePageNavbarPermissions({ navbarItems: pageNavbar });

  return (
    <PageWrapDefault
      className="page-variables"
      dataExist={true}
      title={<Localize>PAGES.Title_Settings</Localize>}
      pageNavbar={filteredNavbarItems}
      staticPath=""
    >
      <div className="table-action-bar">
        <div className="col"> </div>

        <div className="col">
          <PermissionButton
            type="primary"
            icon={<Icons.Plus />}
            onClick={() => navigate(`${basePath}/create`)}
            permission={VariableConst.permissions.UPDATE}
            disabledFallback={true}
          >
            <span className="ellipsis">
              <Localize>GLOBAL.Button_Text_CreateNew</Localize>
            </span>
          </PermissionButton>
        </div>
      </div>

      <Variable.Helpers.TableGroup />
    </PageWrapDefault>
  );
};

export default VariableGroupPage;
